module.exports = __webpack_public_path__ + "static/media/telstraWhite.4e9bce5f.svg";